module.exports = __webpack_public_path__ + "img/gb.a95b4dcc.svg";